import { css } from "@emotion/core";
import { API } from "aws-amplify";
import axios from "axios";
import OwnerSearchModal from "containers/owner/OwnerSearchModal";
import PropertySaleList from "containers/property/PropertySaleList";
import SaleBuyerSellerList from "containers/sale/SaleBuyerSellerList";
import Moment from "moment";
import React, { Component } from "react";
import { Alert, Button, Card, Col, Form, InputGroup, Modal, Nav, Row, Tab, Tabs } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { LinkContainer } from "react-router-bootstrap";
import Select from "react-select";
import { PacmanLoader } from "react-spinners";
import "../common/Detail.css";

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class SaleDetail extends Component {
  constructor(props) {
    super(props);

    this.updateTableState = this.updateTableState.bind(this);
    this.saveRecord = this.saveRecord.bind(this);
    this.refreshDataSet = this.refreshDataSet.bind(this);
    this.validateRelatedRecord = this.validateRelatedRecord.bind(this);
    this.getProperties = this.getProperties.bind(this);
    this.setAppendixNo = this.setAppendixNo.bind(this);
    this.removeHold = this.removeHold.bind(this);

    this.state = {
      isLoading: null,
      isDeleting: null,
      modified: false,
      sale: null,
      showAlert: false,
      errorMessage: "",
      propertyidlist: [],
      textDates: false,
      areaSum: 0,

      saleReviewFilter: {},
      buyerSellerFilter: {},
      propertySaleFilter: {},
      addressFilter: { propertyid: -1 },
      ownerFilter: { propertyid: -1 },

      propertySales: [],
      showPropertySaleDialog: false,
      issueDate: null,
      cityscope: null,
      showOwnerSearchDialog: false,

      buyerSellers: [],

      buyerSellerOptions: [
        { value: false, label: "Buyer" },
        { value: true, label: "Vendor" },
      ],

      selectedSuburb: null,
      suburbOptions: [],

      incomeBasisOptions: [
        { value: "G", label: "Gross" },
        { value: "N", label: "Net" },
      ],
      selectedIncomeBasis: null,

      selectedAppendix: null,
      appendixOptions: [],

      idList: [],
      previousId: null,
      nextId: null,

      property_key: this.props.match.params.propertyid,
      primaryCategory: this.props.location.state ? (this.props.location.state.primaryCategory ? this.props.location.state.primaryCategory : null) : null,
      property_id: null,
      selectedClassification: null,
      classificationOptions: [],
      agentOptions: [],
      coAgentOptions: [],
      agentSearchString: null,
      agentInterstateFlag: false,
      agentMenuIsOpen: false,
      coAgentSearchString: null,
      coAgentInterstateFlag: false,
      coAgentMenuIsOpen: false,
      selectedAgent: null,
      selectedCoAgent: null,
      showAgentDropDown: false,
      showCoAgentDropDown: false,

      sale_id: null,
      sale_date: null,
      contract_date: null,
      transfer_date: null,
      sale_price: null,
      interest_transferred: null,
      city_code: null,
      appendix: null,
      entity_id_agent: null,
      agent: null,
      agent_name: null,
      entity_id_co_agent: null,
      co_agent: null,
      co_agent_name: null,
      tmp_prop: null,
      transfer_number: null,
      sale_notes: null,
      mortgagee_receiver_sale: false,
      off_the_plan: false,
      related_parties: false,
      company_transfer: false,
      includes_car_park: this.props.location.state ? (this.props.location.state.isUnit ? this.props.location.state.isUnit : false) : false,
      extraordinary: false,
      leasehold: false,
      part_interest: false,
      checked_duplicate: false,
      classification_code: null,
      classification: null,
      income: null,
      income_basis: null,
      yieldamt: null,
      income_yield_notes: null,
      is_commercial_office: null,
      is_nla_2000: false,
      strata_office_exception: false,
      date_written_to_monitor: null,
      monitor_cityscope_reference: null,
      created_date: null,
      created_by: "",
      last_edited_date: null,
      last_edited_by: "",
    };
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.match.params.id !== prevProps.match.params.id) {
      console.log("componentDidUpdate");
      console.log("Previous prop.id " + prevProps.match.params.id);
      console.log("New prop.id " + this.props.match.params.id);
      const sale_id = this.props.match.params.id;
      this.setState(
        {
          isLoading: null,
          isDeleting: null,
          modified: false,
          sale: null,
          showAlert: false,
          errorMessage: "",

          textDates: false,
          areaSum: 0,

          saleReviewFilter: { saleid: sale_id },
          buyerSellerFilter: { saleid: sale_id },
          propertySaleFilter: { saleid: sale_id },
          addressFilter: { propertyid: -1 },
          ownerFilter: { propertyid: -1 },

          propertySales: [],
          showPropertySaleDialog: false,
          issueDate: null,
          cityscope: null,
          showOwnerSearchDialog: false,

          buyerSellers: [],

          buyerSellerOptions: [
            { value: false, label: "Buyer" },
            { value: true, label: "Vendor" },
          ],

          selectedSuburb: null,
          suburbOptions: [],

          incomeBasisOptions: [
            { value: "G", label: "Gross" },
            { value: "N", label: "Net" },
          ],
          selectedIncomeBasis: null,

          selectedAppendix: null,
          appendixOptions: [],

          idList: [],
          previousId: null,
          nextId: null,

          property_key: this.props.match.params.propertyid,
          primaryCategory: null,
          property_id: null,
          selectedClassification: null,
          classificationOptions: [],
          agentOptions: [],
          coAgentOptions: [],
          agentSearchString: null,
          agentInterstateFlag: false,
          agentMenuIsOpen: false,
          coAgentSearchString: null,
          coAgentInterstateFlag: false,
          coAgentMenuIsOpen: false,
          selectedAgent: null,
          selectedCoAgent: null,
          showAgentDropDown: false,
          showCoAgentDropDown: false,

          sale_id: sale_id,
          sale_date: null,
          contract_date: null,
          transfer_date: null,
          sale_price: null,
          interest_transferred: null,
          city_code: null,
          appendix: null,
          entity_id_agent: null,
          agent: null,
          agent_name: null,
          entity_id_co_agent: null,
          co_agent: null,
          co_agent_name: null,
          tmp_prop: null,
          transfer_number: null,
          sale_notes: null,
          mortgagee_receiver_sale: false,
          off_the_plan: false,
          related_parties: false,
          company_transfer: false,
          includes_car_park: false,
          extraordinary: false,
          leasehold: false,
          part_interest: false,
          checked_duplicate: false,
          classification_code: null,
          classification: null,
          income: null,
          income_basis: null,
          yieldamt: null,
          income_yield_notes: null,
          is_commercial_office: null,
          is_nla_2000: false,
          strata_office_exception: false,
          date_written_to_monitor: null,
          monitor_cityscope_reference: null,
          created_date: null,
          created_by: "",
          last_edited_date: null,
          last_edited_by: "",
        },
        this.loadNewSale
      );
    }
  }

  componentWillUnmount() {
    console.log("componentWillUnmount");
    //source.cancel();
    this.setState({ sale: {} });
    this.setState({ suburbOptions: [] });
  }

  async componentDidMount() {
    console.log("In saledetail component did mount " + this.props.match.params.id);
    //If not a new sale, get the saleid
    if (this.props.match.params.id.indexOf("new") < 0) {
      this.setState({
        saleReviewFilter: { saleid: this.props.match.params.id },
        buyerSellerFilter: { saleid: this.props.match.params.id },
        propertySaleFilter: { saleid: this.props.match.params.id },
        property_key: this.props.match.params.propertyid,
        primaryCategory: this.props.location.state ? (this.props.location.state.primaryCategory ? this.props.location.state.primaryCategory : null) : null,
        sale_id: this.props.match.params.id,
      });
    }

    if (this.props.location.state) {
      if (this.props.location.state.propertyidlist) {
        this.setState({ propertyidlist: this.props.location.state.propertyidlist });
      }
    }

    try {
      this.setState({ isLoading: true });
      console.log(this.props.match.params.id);
      if (this.props.match.params.id.indexOf("new") >= 0) {
        console.log("New sale");
        this.setState({ property_id: this.props.location.search.replace("?propertyid=", ""), mortgagee_receiver_sale: false, off_the_plan: false, related_parties: false, company_transfer: false, includes_car_park: this.props.location.state ? (this.props.location.state.isUnit ? this.props.location.state.isUnit : false) : false, classification_code: this.state.primaryCategory !== null ? this.state.primaryCategory.classification_code : null, classification: this.state.primaryCategory !== null ? this.state.primaryCategory.classification : null, extraordinary: false, leasehold: false, part_interest: false, checked_duplicate: false, is_nla_2000: false, strata_office_exception: false, is_commercial_office: false, created_by: this.props.user, interest_transferred: 100, cityscope: this.props.match.params.propertyid.substring(0, 2) });
        await this.syncroniseState();
        await this.loadLookupData(this.props.match.params.propertyid.substring(0, 2));
        this.setAppendix();
        this.setState({ selectedClassification: { value: this.state.classification_code, label: this.state.classification } });
        document.title = "New sale for " + this.state.property_key;
      } else {
        console.log("Existing sale");
        await this.loadNewSale();
      }

      this.setState({ isLoading: false });
    } catch (e) {
      alert(e);
    }
  }

  async loadLookupData(cityscope) {
    console.log("loadLookupData");
    const classificationOptions = await this.getClassifications();
    if (classificationOptions) {
      this.setState((state) => ({ classificationOptions }));
    }

    const appendixOptions = await this.getAppendix({ cityscope: cityscope });
    if (appendixOptions) {
      this.setState((state) => ({ appendixOptions }));
    }
  }

  setAppendix() {
    console.log("setAppendix");
    //If we have loaded the appendix options
    if (this.state.appendixOptions) {
      //If the sale already has an appendix, then get the issue_date
      if (this.state.appendix) {
        for (let i = 0; i < this.state.appendixOptions.length; i++) {
          if (this.state.appendixOptions[i].value === this.state.appendix) {
            this.setState({ issue_date: this.state.appendixOptions[i].issue_date });
            console.log("Found appendix match " + this.state.appendixOptions[i].value);
            break;
          }
        }
      }
      //else pick the next appendix date for the scope
      else {
        for (let i = 0; i < this.state.appendixOptions.length; i++) {
          if (this.state.appendixOptions[i].current_appendix == this.state.appendixOptions[i].value) {
            console.log(this.state.appendixOptions[i].value);
            this.setState({ appendix: this.state.appendixOptions[i].value, selectedAppendix: { value: this.state.appendixOptions[i].value, label: this.state.appendixOptions[i].label }, issue_date: this.state.appendixOptions[i].issue_date });
            break;
          }
        }
      }
    }
  }

  async loadNewSale() {
    console.log("loadNewSale");
    await this.retrieveSale();
    //Set drop down values
    this.setState({ selectedAppendix: { value: this.state.appendix, label: this.state.appendix } });
    this.setState({ selectedClassification: { value: this.state.classification_code, label: this.state.classification } });

    if (this.state.income_basis) {
      let label = "";
      try {
        label = this.state.incomeBasisOptions.find((o) => o.value === this.state.income_basis).label;
      } catch {
        label = this.state.income_basis;
      }
      this.setState({ selectedIncomeBasis: { value: this.state.income_basis, label: label } });
    }

    //Handle prev next buttons
    if (this.props.location.state) {
      if (this.props.location.state.hasOwnProperty("data")) {
        const idList = this.props.location.state.data;
        var currentIdIndex = idList.indexOf(parseInt(this.props.match.params.id, 10));

        let nextId = null;
        let previousId = null;

        if (currentIdIndex + 1 < idList.length) {
          nextId = idList[currentIdIndex + 1];
        }
        if (currentIdIndex > 0) {
          previousId = idList[currentIdIndex - 1];
        }
        this.setState({ idList: idList, nextId: nextId, previousId: previousId, currentIdIndex: currentIdIndex });
      }
    }

    //get properties

    await this.getProperties(this.state.propertySaleFilter);

    //Sum property areas
    if (this.state.propertySales.length > 0) {
      let areaSum = 0;
      for (let i = 0; i < this.state.propertySales.length; i++) {
        if (this.state.propertySales[i].hasOwnProperty("site_area")) {
          if (this.state.propertySales[i].site_area !== null) {
            areaSum += this.state.propertySales[i].site_area;
          }
        }
      }
      this.setState({ areaSum });
    }

    //Get buyers / sellers
    try {
      await this.getBuyerSellers(this.state.buyerSellerFilter);
    } catch {
      alert("Error loading property sales");
    }

    //Get lookup data
    if (this.state.propertySales.length > 0) {
      await this.loadLookupData(this.state.propertySales[0].property_key.substring(0, 2));
      this.setAppendix();
    }

    if (this.state.entity_id_agent) {
      this.setState((state) => ({ selectedAgent: { value: this.state.entity_id_agent, label: this.state.agent } }));
    }
    if (this.state.entity_id_co_agent) {
      this.setState((state) => ({ selectedCoAgent: { value: this.state.entity_id_co_agent, label: this.state.co_agent } }));
    }

    if (this.state.entity_id_agent) {
      const agentOptions = await this.getAgents({ entityid: this.state.entity_id_agent });
      this.setState((state) => ({ agentOptions }));
      this.setState((state) => ({ showAgentDropDown: true }));
    }

    if (this.state.entity_id_co_agent) {
      const coAgentOptions = await this.getCoAgents({ entityid: this.state.entity_id_co_agent });
      this.setState((state) => ({ coAgentOptions }));
      this.setState((state) => ({ showCoAgentDropDown: true }));
    }

    document.title = "sale " + this.state.sale_id;
  }

  async syncroniseState() {
    const sale = {
      sale_id: this.state.sale_id,
      sale_date: this.state.sale_date,
      contract_date: this.state.contract_date,
      transfer_date: this.state.transfer_date,
      sale_price: this.state.sale_price,
      interest_transferred: this.state.interest_transferred,
      city_code: this.state.city_code,
      appendix: this.state.appendix,
      issue_date: this.state.issue_date,
      entity_id_agent: this.state.entity_id_agent,
      agent: this.state.agent,
      agent_name: this.state.agent_name,
      entity_id_co_agent: this.state.entity_id_co_agent,
      co_agent: this.state.co_agent,
      co_agent_name: this.state.co_agent_name,
      tmp_prop: this.state.tmp_prop,
      transfer_number: this.state.transfer_number,
      sale_notes: this.state.sale_notes,
      mortgagee_receiver_sale: this.state.mortgagee_receiver_sale,
      off_the_plan: this.state.off_the_plan,
      related_parties: this.state.related_parties,
      company_transfer: this.state.company_transfer,
      includes_car_park: this.state.includes_car_park,
      extraordinary: this.state.extraordinary,
      leasehold: this.state.leasehold,
      part_interest: this.state.part_interest,
      checked_duplicate: this.state.checked_duplicate,
      classification_code: this.state.classification_code,
      classification: this.state.classification,
      income: this.state.income,
      income_basis: this.state.income_basis,
      yieldamt: this.state.yieldamt,
      income_yield_notes: this.state.income_yield_notes,
      is_commercial_office: this.state.is_commercial_office,
      is_nla_2000: this.state.is_nla_2000,
      strata_office_exception: this.state.strata_office_exception,
      date_written_to_monitor: this.state.date_written_to_monitor,
      monitor_cityscope_reference: this.state.monitor_cityscope_reference,
      created_date: this.state.created_date,
      created_by: this.state.created_by,
      last_edited_date: this.state.last_edited_date,
      last_edited_by: this.state.last_edited_by,
    };

    this.setState({ sale });
  }

  async retrieveSale() {
    const sale = await this.getSale();

    const { sale_id, sale_date, contract_date, transfer_date, sale_price, interest_transferred, city_code, appendix, issue_date, entity_id_agent, agent, agent_name, entity_id_co_agent, co_agent, co_agent_name, tmp_prop, transfer_number, sale_notes, mortgagee_receiver_sale, off_the_plan, related_parties, company_transfer, includes_car_park, extraordinary, leasehold, part_interest, checked_duplicate, classification_code, classification, income, income_basis, yieldamt, income_yield_notes, is_commercial_office, is_nla_2000, strata_office_exception, date_written_to_monitor, monitor_cityscope_reference, created_date, created_by, last_edited_date, last_edited_by } = sale;

    this.setState({
      sale,
      sale_id,
      sale_date,
      contract_date,
      transfer_date,
      sale_price,
      interest_transferred,
      city_code,
      appendix,
      issue_date,
      entity_id_agent,
      agent,
      agent_name,
      entity_id_co_agent,
      co_agent,
      co_agent_name,
      tmp_prop,
      transfer_number,
      sale_notes,
      mortgagee_receiver_sale,
      off_the_plan,
      related_parties,
      company_transfer,
      includes_car_park,
      extraordinary,
      leasehold,
      part_interest,
      checked_duplicate,
      classification_code,
      classification,
      income,
      income_basis,
      yieldamt,
      income_yield_notes,
      is_commercial_office,
      is_nla_2000,
      strata_office_exception,
      date_written_to_monitor,
      monitor_cityscope_reference,
      created_date,
      created_by,
      last_edited_date,
      last_edited_by,
    });
  }

  //Call API
  getSale() {
    console.log("inside of getSale");
    return API.get("colin", `/sales/${this.props.match.params.id}`, { cancelToken: source.token })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async saveSale(sale) {
    console.log("Inside save sale");
    this.setState({ last_edited_by: this.props.user });
    if (this.state.sale_id === null) {
      this.setState({ created_by: this.props.user });
      const response = await API.post("colin", `/sales/new`, { body: sale });
      try {
        return await response;
      } catch (error) {
        alert(error + ". Please refresh the page (F5) to try again.");
      }
    }
    const response = await API.put("colin", `/sales/${this.state.sale_id}`, { body: sale });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async removeHold() {
    const confirm2 = window.confirm("Please confirm you have proofed this sale and would like to update the HOLD status of the Properties linked to this Sale?");
    if (confirm2) {
      try {
        const sale = { last_edited_by: this.props.user, released_by: this.props.user };
        const response = await API.put("colin", `/sales/${this.state.sale_id}/withholdings/all`, { body: sale });

        let propertySales = [...this.state.propertySales];
        var i = 0;
        for (i = 0; i < propertySales.length; i++) {
          propertySales[i].withhold_flag = false;
        }
        this.setState({ propertySales });

        return response;
      } catch (error) {
        alert(error + ". Please refresh the page (F5) to try again.");
      }
    }
  }
  async savePropertySaleText(sale) {
    console.log("Inside save sale text");
    sale.last_edited_by = this.props.user;
    return API.put("colin", `/properties/${sale.property_id}/appendsaleshistory`, {
      body: sale,
    });
  }

  getAgents(filter) {
    try {
      console.log(filter);
      API.get("colin", `/entities/dropdown`, { queryStringParameters: filter, cancelToken: source.token }).then((agentOptions) => {
        if (agentOptions) {
          this.setState((state) => ({ agentOptions }));
        }
      });
    } catch {
      console.log("Error getting agents");
    }
  }

  getCoAgents(filter) {
    try {
      API.get("colin", `/entities/dropdown`, { queryStringParameters: filter, cancelToken: source.token }).then((coAgentOptions) => {
        if (coAgentOptions) {
          this.setState((state) => ({ coAgentOptions }));
        }
      });
    } catch {
      console.log("Error getting agents");
    }
  }

  getSuburbs() {
    return API.get("colin", `/suburbs`);
  }

  getClassifications() {
    return API.get("colin", `/classifications`);
  }

  async getProperties(filter) {
    console.log("In getProperties");
    await API.get("colin", "/propertysales", { queryStringParameters: filter, cancelToken: source.token })
      .then((propertySales) => {
        if (propertySales) {
          if (propertySales[0].hasOwnProperty("property_key")) {
            propertySales.sort(function (a, b) {
              if (a.property_key === b.property_key) {
                return 0;
              }
              if (a.property_key < b.property_key) {
                return -1;
              } else {
                return 1;
              }
            });
          }
          this.setState((state) => ({ propertySales }));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getBuyerSellers(filter) {
    try {
      API.get("colin", "/sales/buyersellers", { queryStringParameters: filter, cancelToken: source.token }).then((buyerSellers) => {
        if (buyerSellers) {
          this.setState((state) => ({ buyerSellers }));
        }
      });
    } catch {
      console.log("Error getting buyer sellers");
    }
  }

  getAppendix(filter) {
    try {
      return API.get("colin", "/appendix", { queryStringParameters: filter, cancelToken: source.token });
    } catch {
      console.log("Error getting appendix");
    }
  }

  handleEnterCurrentIdIndex = (event) => {
    if (event.keyCode === 13 || event.keyCode === 9) {
      this.handleGoToRecord();
    }
  };

  handleGoToRecord = (event) => {
    console.log(this.state.idList.length);
    if (this.state.currentIdIndex >= 0 && this.state.currentIdIndex < this.state.idList.length) {
      this.props.history.push({ pathname: `/sales/${this.state.idList[this.state.currentIdIndex]}`, state: { data: this.state.idList, propertyidlist: this.state.propertyidlist } });
    } else {
      alert("Page no not in range.");
    }
  };

  handleCurrentIdIndexChange = (event) => {
    const val = event.target.value.replace(/[^0-9.]/g, "");
    this.setState({ [event.target.id]: val - 1 });
  };

  handleSuburbChange = (selectedSuburb) => {
    this.setState({ selectedSuburb, suburb: selectedSuburb, modified: true }, this.handleBlur);
  };

  handleIncomeBasisChange = (selectedIncomeBasis) => {
    if (selectedIncomeBasis) {
      this.setState({ selectedIncomeBasis, income_basis: selectedIncomeBasis.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedIncomeBasis: { value: null, label: null }, income_basis: null, modified: true }, this.handleBlur);
    }
  };

  handleClassificationChange = (selectedClassification) => {
    this.setState({ selectedClassification });
    if (selectedClassification) {
      this.setState({ classification_code: selectedClassification.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ classification_code: null, modified: true }, this.handleBlur);
    }
  };

  handleAppendixChange = (selectedAppendix) => {
    this.setState({ selectedAppendix });
    if (selectedAppendix) {
      this.setState({ appendix: selectedAppendix.value, issue_date: selectedAppendix.issue_date, modified: true }, this.handleBlur);
    } else {
      this.setState({ appendix: null, issue_date: null, modified: true }, this.handleBlur);
    }
  };

  handleAgentSearch = async () => {
    try {
      console.log(this.state.agentSearchString);
      let state = null;
      if (!this.state.agentInterstateFlag) {
        if (this.state.propertySales.length > 0) {
          state = this.state.propertySales[0].state;
        }
      }

      await this.getAgents({ name: this.state.agentSearchString, state: state });
      this.setState({ agentMenuIsOpen: true });
    } catch {
      alert("Error loading agents");
    }
  };

  handleCoAgentSearch = async () => {
    try {
      console.log(this.state.coAgentSearchString);
      let state = null;
      if (!this.state.coAgentInterstateFlag) {
        if (this.state.propertySales.length > 0) {
          state = this.state.propertySales[0].state;
        }
      }
      await this.getCoAgents({ name: this.state.coAgentSearchString, state: state });
      this.setState({ coAgentMenuIsOpen: true });
    } catch {
      alert("Error loading agents");
    }
  };

  handleEnterOnAgentSearch = (e) => {
    if (e.keyCode === 13) {
      this.handleAgentSearch();
    }
  };

  handleEnterOnCoAgentSearch = (e) => {
    if (e.keyCode === 13) {
      this.handleCoAgentSearch();
    }
  };

  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    });
    this.setState({ modified: true });
  };

  handlePercentChange = (event) => {
    let val = event.target.value.replace(/[^0-9.]/g, "").replace(/(?<=[.][0-9]{2})[0-9]*/g, "");
    if (val > 100) {
      val = 100;
    }
    let partInterest = this.state.part_interest;

    if (event.target.id === "interest_transferred") {
      if (val !== 100) {
        partInterest = true;
      } else {
        partInterest = false;
      }
    }

    this.setState({ [event.target.id]: val, modified: true, part_interest: partInterest });
  };

  handleNumberChange = (event) => {
    let val = event.target.value.replace(/[^0-9.]/g, "");
    this.setState({
      [event.target.id]: val,
    });
    this.setState({ modified: true });
  };

  handleMoneyChange = (event) => {
    if (event.target.value !== "") {
      let val = event.target.value;
      this.setState({ [event.target.id]: val, modified: true });
    } else {
      this.setState({ [event.target.id]: null, modified: true });
    }
  };

  formatMoney = (value) => {
    return new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 2,
      currencyDisplay: "symbol",
    }).format(value);
  };

  handleDateChange(date, name) {
    var options = { year: "numeric", month: "long", day: "numeric" };
    var dt = new Date(date);

    if (date) {
      this.setState(
        {
          [name]: dt.toLocaleDateString("en-AU", options),
          modified: true,
        },
        this.setSaleDate
      );
    } else {
      this.setState({
        [name]: null,
        modified: true,
      });
    }
  }

  handleCheckBoxChange = (event) => {
    let name = event.target.name;
    this.setState(
      {
        [name]: event.target.checked,
        modified: true,
      },
      this.handleBlur
    );
  };

  handleAgentChange = async (selectedAgent) => {
    this.setState({ selectedAgent });
    if (selectedAgent) {
      this.setState({ entity_id_agent: selectedAgent.value, agent: selectedAgent.label, agent_name: selectedAgent.name, modified: true }, this.handleBlur);
    } else {
      this.setState({ entity_id_agent: null, agent: null, agent_name: null, modified: true }, this.handleBlur);
    }
    this.setState({ agentMenuIsOpen: false });
  };

  handleCoAgentChange = async (selectedCoAgent) => {
    this.setState({ selectedCoAgent });
    if (selectedCoAgent) {
      this.setState({ entity_id_co_agent: selectedCoAgent.value, co_agent: selectedCoAgent.label, co_agent_name: selectedCoAgent.name, modified: true }, this.handleBlur);
    } else {
      this.setState({ entity_id_co_agent: null, co_agent: null, co_agent_name: null, modified: true }, this.handleBlur);
    }
    this.setState({ coAgentMenuIsOpen: false });
  };

  validateRelatedRecord(record, set) {
    //property
    if (set === "sale") {
      //Sale Date
      if (!this.state.sale_date) {
        return [false, "You must enter a sale date."];
      }

      if (this.state.yieldamt) {
        if (this.state.yieldamt < 0 || this.state.yieldamt > 100) {
          return [false, "Yield must be a number between 0 and 100."];
        }
      }

      if (this.state.interest_transferred !== null && this.state.interest_transferred !== "") {
        if (this.state.interest_transferred < 0 || this.state.interest_transferred > 100) {
          return [false, "Interest Transferred must be a number between 0 and 100."];
        }
      }
    }

    if (set === "propertySales") {
      // secondly check that UnitSort has been specified if required

      if (!record.property_key) {
        return [false, "Enter a Cityscope reference."];
      }
    }

    if (set === "buyerSellers") {
      // secondly check that UnitSort has been specified if required

      // if (!record.share) {
      //     return [false, "Enter buyer share."];
      // }

      if (record.share !== null && record.share !== "") {
        if (record.share > 100 || record.share < 0) {
          return [false, "Enter buyer share between 0 and 100%"];
        }
      }
    }

    return [true];
  }

  setAppendixNo() {
    let dt = new Date(this.state.sale_date);
    dt = dt.setDate(dt.getDate() + 30);
    console.log(dt);
    if (dt < new Date(Date.parse("1999-01-01"))) {
      this.setState({ issue_date: null, selectedAppendix: null, appendix: null, modified: true }, this.handleBlur);
    } else {
      console.log("Finding appendix option");
      var appendixOptions = [...this.state.appendixOptions].sort(function (a, b) {
        if (a.issue_date < b.issue_date) {
          return -1;
        } else if (a.issue_date > b.issue_date) {
          return 1;
        } else return 0;
      });
      console.log(appendixOptions);
      for (var i = 0; i < appendixOptions.length; i++) {
        //the appendix list should already be sorted by date in ascending order
        console.log(appendixOptions[i].issue_date);

        if (new Date(appendixOptions[i].issue_date) > dt) {
          this.setState({ issue_date: appendixOptions[i].issue_date, selectedAppendix: { value: appendixOptions[i].value, label: appendixOptions[i].label }, appendix: appendixOptions[i].value || "", modified: true }, this.handleBlur);
          return;
        }
      }
    }
  }

  async setSaleDate() {
    console.log("setSaleDate");
    let sale_date = this.state.sale_date;

    if (this.state.contract_date != null) {
      sale_date = this.state.contract_date;
    } else if (this.state.transfer_date != null) {
      sale_date = this.state.transfer_date;
    } else {
      sale_date = this.state.sale_date;
    }

    this.setState({ sale_date });
  }

  async calculateYield() {
    console.log("In calculateYield");
    const formatter = new Intl.NumberFormat("en-AU", {
      style: "percent",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    if (this.state.sale_price) {
      if (this.state.income) {
        //does yield already have a value?
        if (this.state.yieldamt) {
          const confirm = window.confirm("Is it OK to overwrite the current value of Yield with the new value " + formatter.format(this.state.income.replace(/[^0-9.]/g, "") / this.state.sale_price.replace(/[^0-9.]/g, "")) + "?");
          if (!confirm) {
            return;
          }
        }
        this.setState({ yieldamt: ((this.state.income.replace(/[^0-9.]/g, "") / this.state.sale_price.replace(/[^0-9.]/g, "")) * 100).toFixed(2) });
      } else {
        if (this.state.yieldamt) {
          const confirm2 = window.confirm("Yield cannot be calculated from the current values of Sale Price and Income. Should the current value of Yield " + formatter.format(this.state.yieldamt) + " be cleared?");
          if (confirm2) {
            this.setState({ yieldamt: null });
            return;
          }
        }
      }
    } else {
      this.setState({ yieldamt: null });
      return;
    }
  }

  async calculateIncome() {
    console.log("In calculateIncome");
    const formatter = new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 0,
      currencyDisplay: "symbol",
    });

    if (this.state.sale_price) {
      if (this.state.yieldamt) {
        //does income already have a value?
        if (this.state.income) {
          const confirm = window.confirm("Is it OK to overwrite the current value of Income with the new value " + formatter.format((this.state.yieldamt / 100) * this.state.sale_price.replace(/[^0-9.]/g, "")) + "?");
          if (!confirm) {
            return;
          }
        }
        this.setState({ income: formatter.format((this.state.yieldamt / 100) * this.state.sale_price.replace(/[^0-9.]/g, "")) });
      } else {
        const confirm2 = window.confirm("Income cannot be calculated from the current values of Sale Price and Yield. Should the current value of Income " + formatter.format(this.state.income) + " be cleared?");
        if (!confirm2) {
          this.setState({ income: null });
        }
      }
    } else {
      this.setState({ income: null });
      return;
    }
  }

  handleBlur = async (event) => {
    console.log("Inside handle blur");
    if (event) {
      event.persist();

      if (event.target) {
        const formatMoney = (value) => this.formatMoney(parseFloat(value.replace(/[^0-9.]/g, "")).toFixed(2));

        if (event.target.id === "income" && this.state.modified) {
          await this.setState({ income: formatMoney(this.state.income) });
          await this.calculateYield();
        }

        if (event.target.id === "yieldamt" && this.state.modified) {
          await this.calculateIncome();
        }
      }
    }
    if (this.state.modified === true) {
      console.log("Modified");
      this.setState({ showAlert: false, last_edited_by: this.props.user });
      await this.syncroniseState();

      const validation = this.validateRelatedRecord(this.state.sale, "sale");
      console.log(validation);
      if (validation[0] === true) {
        this.setState((state) => ({ modified: false })); //
        if (this.state.entity_id_agent !== null) {
          if (this.state.agent.indexOf("INACTIVE") > 0) {
            this.setState({ errorMessage: "You have selected an inactive  agent, please consider if this is correct. The record will still be saved." });
            this.setState({ showAlert: true });
          }
          if (this.state.propertySales.length > 0 && this.state.propertySales[0].state) {
            if (this.state.agent.toUpperCase().indexOf(this.state.propertySales[0].state.toUpperCase()) === -1) {
              this.setState({ errorMessage: "You have selected an agent in another state, please consider if this is correct. The record will still be saved." });
              this.setState({ showAlert: true });
            }
          }
        }
        if (this.state.entity_id_co_agent !== null) {
          if (this.state.co_agent.indexOf("INACTIVE") > 0) {
            this.setState({ errorMessage: "You have selected an inactive co agent, please consider if this is correct. The record will still be saved." });
            this.setState({ showAlert: true });
          }
          if (this.state.propertySales.length > 0 && this.state.propertySales[0].state) {
            if (this.state.co_agent.toUpperCase().indexOf(this.state.propertySales[0].state.toUpperCase()) === -1) {
              this.setState({ errorMessage: "You have selected a co agent in another state, please consider if this is correct. The record will still be saved." });
              this.setState({ showAlert: true });
            }
          }
        }

        try {
          if (this.props.match.params.id.indexOf("new") >= 0) {
            this.setState({ isLoading: true });
          }
          console.log("Saving sale");
          const result = await this.saveSale(this.state.sale);
          this.setState({ isLoading: false });
          if (result.result === false) {
            alert(result.error_message);
          } else {
            if (this.props.match.params.id.indexOf("new") >= 0) {
              this.setState((state) => ({ sale_id: result.id }));
              //Create relation to property
              await this.addPropertyRelation(result.id);

              this.props.history.push("/sales/" + this.state.sale_id);
              //Refresh properties and the actual sales so we can return info from the db
              //  await this.getProperties({ saleid: result.id });
              //   await this.retrieveSale();
              if (!this.state.appendix && this.state.propertySales.length > 0) {
                this.setState({ appendix: this.state.propertySales[0].current_appendix, selectedAppendix: { value: this.state.propertySales[0].current_appendix, label: this.state.propertySales[0].current_appendix } });
              }
            }
          }
        } catch (e) {
          alert(e);
        }
      } else {
        this.setState({ errorMessage: validation[1] });
        this.setState({ showAlert: true });
      }
    }
  };

  async refreshDataSet(dataset) {
    //Get nabers records
    console.log("Inside refresh ");
    if (dataset === "buyerSellers") {
      try {
        await this.getBuyerSellers(this.state.buyerSellerFilter);
      } catch {
        alert("Error loading property sales");
      }
    }
  }

  updateTableState(data, set) {
    this.setState({
      [set]: data,
    });
  }

  async saveRecord(record, endpoint, id) {
    console.log("Inside save record");
    record.last_edited_by = this.props.user;
    //If the record is a new record perform a post
    if (record.hasOwnProperty("new_record")) {
      if (record.new_record === true) {
        record.last_edited_by = this.props.user;
        if (endpoint !== "propertySales") {
          return await API.post("colin", `/sales/${this.state.sale_id}/${endpoint.toLowerCase()}/new`, {
            body: record,
          });
        } else {
          return await API.post("colin", `/${endpoint.toLowerCase()}/new`, {
            body: record,
          });
        }
      }
    }
    //If not a new record and updating an existing, perform a put
    if (endpoint !== "propertySales") {
      return API.put("colin", `/sales/${this.state.sale_id}/${endpoint.toLowerCase()}/${record[id]}`, {
        body: record,
      });
    } else {
      return API.put("colin", `/${endpoint.toLowerCase()}/${record[id]}`, {
        body: record,
      });
    }
  }

  async addPropertyRelation(saleId) {
    console.log("Inside add property relation");
    let data = [...this.state.propertySales];

    //Update the following with the minimum details to create a record (all not nulls populated)
    //Requires updating per dataset
    let last_sale = Math.ceil(Math.abs(new Date(this.state.sale_date).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)) < 365 ? true : false;
    if (data.length === 0) {
      last_sale = true;
    }

    data.push({
      property_id: this.state.property_id,
      property_key: this.state.property_key,
      sale_id: saleId,
      created_by: this.props.user,
      last_edited_by: this.props.user,
      last_sale: last_sale,
      new_record: true,
    });

    this.updateTableState(data, "propertySales");

    const result = await this.saveRecord(data[0], "propertySales", "property_sale_id");
    console.log(result);
    if (result.result) {
      data[0].property_sale_id = result.id;
      data[0].new_record = false;
      this.updateTableState(data, "propertySales");
    } else {
      this.setState({ errorMessage: result.error_message });
      this.setState({ showAlert: true });
    }

    return;
  }

  //This should be pushed back to the DB. We did it here originally because the user may not apply the change once generated, but the function to
  // create the text could still sit in the db
  handleBuildSalesText = async (event) => {
    let strText = "";

    try {
      const response = await API.get("colin", `/sales/${this.props.match.params.id}/salestext`, { queryStringParameters: { dates_as_text: this.state.textDates } });
      strText = response[0].sales_text_not_suppressed;
    } catch (e) {
      console.error("Unable to build sales text:", e);
      alert("Unable to build sales text.");
      return;
    }

    const pasteToProperties = window.confirm(strText + "\n\nDo you want to paste this text at the end of the Sales History paragraphs for each of the properties involved in the sale?");

    if (pasteToProperties) {
      for (var i = 0; i < this.state.propertySales.length; i++) {
        await this.savePropertySaleText({ property_id: this.state.propertySales[i].property_id, sales_text: strText });
      }
      alert("The text has been successfully appended to the end of the Sale History paragraph. THE ENTRY STILL NEEDS TO BE PROOFED AND EDITED.");
    } else {
      alert("No text was pasted.");
    }
  };

  handleDelete = async (event) => {
    event.preventDefault();
    if (event.detail !== 0) {
      if (!this.state.registered) {
        if (this.state.propertySales.length === 0) {
          if (this.state.buyerSellers.length === 0) {
            const confirmed = window.confirm("Are you sure you want to delete this sale?");

            if (!confirmed) {
              return;
            } else {
              this.setState({ archived_date: new Date() }, () =>
                this.syncroniseState().then(async () => {
                  const result = await this.saveSale(this.state.sale);
                  if (result.result === false) {
                    alert(result.error_message);
                  } else {
                    this.props.history.push("/properties");
                  }
                })
              );
            }
          } else {
            window.alert("Sale cannot be deleted as it is linked to buyers/sellers");
          }
        } else {
          window.alert("Sale cannot be deleted as it is linked to properties");
        }
      } else {
        window.alert("Record cannot be deleted");
      }
    }
  };

  toggleOwnerSearchDialog = async () => {
    this.setState({
      showOwnerSearchDialog: !this.state.showOwnerSearchDialog,
    });
  };

  togglePropertySaleModal = () => {
    this.setState({
      showPropertySaleDialog: !this.state.showPropertySaleDialog,
    });
  };

  removeVendorAsOwner = async () => {
    const confirmed = window.confirm("Remove the vendors of this sale from all Properties linked to this sale?");

    if (confirmed) {
      //back end handles the blank body and grabs all owners against a sale id
      await API.put("colin", `/propertyowners/frombuyervendor`, { body: { created_by: this.props.user, last_edited_by: this.props.user, saleid: this.state.sale_id } });
    }
  };
  addOwnerAsBuyerSeller = async () => {
    const confirmed = window.confirm("Add the current Property Owners to this Sale as Buyers/Vendors?");

    if (confirmed) {
      //back end handles the blank body and grabs all owners against a sale id
      await API.post("colin", `/sales/${this.state.sale_id}/buyersellers/fromproperty`, { body: { created_by: this.props.user, last_edited_by: this.props.user, buyer_vendor: true } });

      await API.post("colin", `/sales/${this.state.sale_id}/buyersellers/fromproperty`, { body: { created_by: this.props.user, last_edited_by: this.props.user, buyer_vendor: false } });
    }
    this.refreshDataSet("buyerSellers");
  };

  render() {
    return (
      <div className="Sale">
        {this.state.isLoading && (
          <div className="outer-div">
            <div className="sweet-loading inner-div">
              <PacmanLoader
                css={css`
                  display: block;
                  margin: 0 auto;
                  border-color: red;
                `}
                sizeUnit={"px"}
                size={20}
                color={"#e03c31"}
                loading={this.state.isLoading}
              />
            </div>
          </div>
        )}
        {this.state.showOwnerSearchDialog && <OwnerSearchModal isAuthenticated={this.props.isAuthenticated} user={this.props.user} toggleOwnerSearchDialog={this.toggleOwnerSearchDialog} show={this.state.showOwnerSearchDialog} saleid={this.state.sale_id} properties={this.state.propertySales} controlType="table1" buyerSellers={this.state.buyerSellers} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} refreshDataSet={this.refreshDataSet} />}

        {this.state.sale && this.props.isAuthenticated && !this.state.isLoading && (
          <div className="SaleForm">
            <Form>
              <Row>
                <Col lg={3}></Col>
                <Col>
                  <Nav className="justify-content-center ">
                    {this.state.previousId !== null && this.state.idList.length > 0 && (
                      <Nav.Item>
                        <LinkContainer to={{ pathname: `/sales/${this.state.previousId}`, state: { data: this.state.idList, propertyidlist: this.state.propertyidlist } }}>
                          <Button type="button" variant="info" size="sm">
                            Previous
                          </Button>
                        </LinkContainer>{" "}
                      </Nav.Item>
                    )}
                    {this.state.nextId !== null && this.state.idList.length > 0 && (
                      <Nav.Item>
                        <LinkContainer to={{ pathname: `/sales/${this.state.nextId}`, state: { data: this.state.idList, propertyidlist: this.state.propertyidlist } }}>
                          <Button type="button" variant="info" size="sm">
                            Next
                          </Button>
                        </LinkContainer>{" "}
                      </Nav.Item>
                    )}
                    {this.state.currentIdIndex !== null && this.state.idList.length > 0 && (
                      <Form.Group as={Row} controlId="currentIdIndex">
                        <Col className="zeroPadRight">
                          <Form.Control onChange={this.handleCurrentIdIndexChange} value={this.state.currentIdIndex + 1} as="input" type="text" min="0" className="pageCount" onBlur={this.handleGoToRecord} onKeyDown={this.handleEnterCurrentIdIndex} />
                        </Col>
                        <Col className="zeroPadLeft">
                          <h6>
                            <div className="topPad">of {this.state.idList.length} </div>
                          </h6>
                        </Col>
                      </Form.Group>
                    )}
                  </Nav>
                </Col>
                <Col>
                  <Nav className="justify-content-end ">
                    <Nav.Item>
                      <a target="_blank" href="/cityscopes">
                        <Button variant="primary" type="button" size="sm">
                          Add/Edit Cityscopes
                        </Button>{" "}
                      </a>
                    </Nav.Item>

                    {/* <Nav.Item>

                            {this.state.propertySales.length>0 && <LinkContainer to={`/properties/${this.state.propertySales[0].property_key}`} >
                                <Button type="button" variant="primary" size="sm">Back to Property {this.state.propertySales[0].property_key}</Button></LinkContainer>}
                                {" "}
                                </Nav.Item> */}
                    <Nav.Item>
                      <Button type="button" variant="primary" size="sm" onClick={this.handleBuildSalesText}>
                        Build Sales Text
                      </Button>{" "}
                      <Form.Check checked={this.state.textDates} onChange={this.handleCheckBoxChange} label="Dates as Text" type="checkbox" name="textDates" size="sm" onBlur={this.handleBlur} />
                    </Nav.Item>
                    <Nav.Item>
                      <Button type="button" variant="danger" onClick={this.handleDelete} size="sm">
                        Delete
                      </Button>
                    </Nav.Item>
                  </Nav>
                </Col>
              </Row>
              <Row id="detail">
                <Col>
                  <Modal
                    show={this.state.showAlert}
                    onHide={(e) => {
                      this.setState({ showAlert: !this.state.showAlert });
                    }}
                    centered
                  >
                    <Modal.Header closeButton>
                      {" "}
                      <Modal.Title>Uh Oh!</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {" "}
                      <Alert variant="danger">{this.state.errorMessage}</Alert>{" "}
                    </Modal.Body>
                  </Modal>
                  <Tabs defaultActiveKey={0} id="tabset">
                    <Tab eventKey={0} title="Sale Detail">
                      <Card id="saledetails">
                        <Card.Body>
                          <Form.Row>
                            <Col sm={12} md={6} lg={3}>
                              <Card id="col1head1">
                                <Card.Header> </Card.Header>

                                <Card.Body>
                                  <Form.Group as={Form.Row} controlId="sale_id">
                                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                                      ID
                                    </Form.Label>
                                    <Col>
                                      <Form.Control readOnly value={this.state.sale_id} as="input" type="text" />
                                    </Col>
                                  </Form.Group>
                                  <Form.Group as={Form.Row} controlId="sale_date">
                                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                                      Sale Date
                                    </Form.Label>
                                    <Col>
                                      <DatePicker
                                        selected={this.state.sale_date !== null ? new Date(this.state.sale_date) : null}
                                        onChange={(e) => this.handleDateChange(e, "sale_date")}
                                        onBlur={this.handleBlur}
                                        //  onClickOutside = {this.handleBlur}
                                        dateFormat="dd/MM/yyyy"
                                        className="form-control"
                                        isClearable={true}
                                      />
                                    </Col>
                                  </Form.Group>
                                  <Form.Group as={Form.Row} controlId="contract_date">
                                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                                      Contract Date
                                    </Form.Label>
                                    <Col>
                                      <DatePicker
                                        selected={this.state.contract_date !== null ? new Date(this.state.contract_date) : null}
                                        onChange={(e) => this.handleDateChange(e, "contract_date")}
                                        onBlur={this.handleBlur}
                                        //   onClickOutside = {this.handleBlur}
                                        dateFormat="dd/MM/yyyy"
                                        className="form-control"
                                        isClearable={true}
                                      />
                                    </Col>
                                  </Form.Group>
                                  <Form.Group as={Form.Row} controlId="transfer_date">
                                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                                      Transfer Date
                                    </Form.Label>
                                    <Col>
                                      <DatePicker
                                        selected={this.state.transfer_date !== null ? new Date(this.state.transfer_date) : null}
                                        onChange={(e) => this.handleDateChange(e, "transfer_date")}
                                        onBlur={this.handleBlur}
                                        //    onClickOutside = {this.handleBlur}
                                        dateFormat="dd/MM/yyyy"
                                        className="form-control"
                                        isClearable={true}
                                      />
                                    </Col>
                                  </Form.Group>
                                  <Form.Group as={Form.Row} controlId="sale_price">
                                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                                      Sale Price
                                    </Form.Label>
                                    <Col>
                                      <InputGroup>
                                        <InputGroup.Prepend>
                                          <InputGroup.Text>$</InputGroup.Text>
                                        </InputGroup.Prepend>
                                        <Form.Control onChange={this.handleMoneyChange} value={this.state.sale_price} as="input" type="text" onBlur={this.handleBlur} />
                                      </InputGroup>
                                    </Col>
                                  </Form.Group>

                                  <Form.Group as={Form.Row} controlId="appendix">
                                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                                      Appendix
                                    </Form.Label>
                                    <Col>
                                      <Select value={this.state.selectedAppendix} onChange={this.handleAppendixChange} options={this.state.appendixOptions} onBlur={this.handleBlur} />
                                    </Col>
                                    <Col>
                                      <Button type="button" size="sm" variant="info" onClick={this.setAppendixNo}>
                                        Assign Historical
                                      </Button>
                                    </Col>
                                  </Form.Group>

                                  <Form.Group as={Form.Row} controlId="issue_date">
                                    <Form.Label as={Col} className="text-right" size="sm" column sm={6} md={6} lg={4}>
                                      Issue Date
                                    </Form.Label>
                                    <Col>
                                      <Form.Control value={this.state.issue_date !== null ? Moment(this.state.issue_date).local().format("DD-MM-YYYY") : ""} plaintext readOnly />
                                    </Col>
                                  </Form.Group>

                                  <Form.Group as={Form.Row} controlId="classification_code">
                                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                                      Classification
                                    </Form.Label>
                                    <Col>
                                      <Select value={this.state.selectedClassification} onChange={this.handleClassificationChange} options={this.state.classificationOptions} onBlur={this.handleBlur} isClearable />
                                    </Col>
                                  </Form.Group>

                                  <Form.Group as={Form.Row} controlId="income">
                                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                                      Income
                                    </Form.Label>
                                    <Col>
                                      <InputGroup>
                                        <InputGroup.Prepend>
                                          <InputGroup.Text>$</InputGroup.Text>
                                        </InputGroup.Prepend>
                                        <Form.Control onChange={this.handleMoneyChange} value={this.state.income} as="input" type="text" onBlur={this.handleBlur} />
                                      </InputGroup>
                                    </Col>
                                  </Form.Group>

                                  <Form.Group as={Form.Row} controlId="income_basis">
                                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                                      Income Basis
                                    </Form.Label>
                                    <Col>
                                      <Select value={this.state.selectedIncomeBasis} onChange={this.handleIncomeBasisChange} options={this.state.incomeBasisOptions} onBlur={this.handleBlur} isClearable />
                                    </Col>
                                  </Form.Group>

                                  <Form.Group as={Form.Row} controlId="yieldamt">
                                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                                      Yield
                                    </Form.Label>
                                    <Col>
                                      <InputGroup>
                                        <Form.Control onChange={this.handlePercentChange} value={this.state.yieldamt !== null ? this.state.yieldamt + "%" : ""} as="input" type="text" onBlur={this.handleBlur} placeholder="0.00 to 100.00" />
                                        <InputGroup.Append>
                                          <InputGroup.Text>%</InputGroup.Text>
                                        </InputGroup.Append>
                                      </InputGroup>
                                    </Col>
                                  </Form.Group>

                                  <Form.Group as={Form.Row} controlId="income_yield_notes">
                                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                                      Income/Yield Notes
                                    </Form.Label>
                                    <Col>
                                      <Form.Control onChange={this.handleChange} value={this.state.income_yield_notes} as="textarea" rows="2" onBlur={this.handleBlur} />
                                    </Col>
                                  </Form.Group>

                                  <Form.Group as={Form.Row} controlId="interest_transferred">
                                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                                      Interest Transferred
                                    </Form.Label>
                                    <Col>
                                      <InputGroup>
                                        <Form.Control onChange={this.handlePercentChange} value={this.state.interest_transferred} as="input" type="text" onBlur={this.handleBlur} placeholder="0.00 to 100.00" />
                                        <InputGroup.Append>
                                          <InputGroup.Text>%</InputGroup.Text>
                                        </InputGroup.Append>
                                      </InputGroup>
                                    </Col>
                                  </Form.Group>

                                  <Form.Group as={Form.Row} controlId="transfer_number">
                                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                                      Transfer No.
                                    </Form.Label>
                                    <Col>
                                      <Form.Control onChange={this.handleChange} value={this.state.transfer_number} as="input" type="text" onBlur={this.handleBlur} />
                                    </Col>
                                  </Form.Group>
                                </Card.Body>
                              </Card>
                              <Card>
                                <Card.Header>Duplicate Check</Card.Header>
                                <Card.Body>
                                  <Form.Group as={Row} controlId="checked_duplicate">
                                    <Col>
                                      <Form.Check checked={this.state.checked_duplicate} onChange={this.handleCheckBoxChange} label="Checked NOT duplicate. (See proofing procedures)" type="checkbox" name="checked_duplicate" onBlur={this.handleBlur} />
                                    </Col>
                                  </Form.Group>
                                </Card.Body>
                              </Card>
                            </Col>

                            <Col sm={12} md={6} lg={3}>
                              <Card id="col2head1">
                                <Card.Header> </Card.Header>

                                <Card.Body>
                                  <Form.Row>
                                    <Col>
                                      <Form.Group as={Row} controlId="part_interest">
                                        <Col>
                                          <Form.Check checked={this.state.part_interest} onChange={this.handleCheckBoxChange} label="Partial Interest Only" type="checkbox" name="part_interest" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>
                                      <Form.Group as={Row} controlId="mortgagee_receiver_sale">
                                        <Col>
                                          <Form.Check checked={this.state.mortgagee_receiver_sale} onChange={this.handleCheckBoxChange} label="Mortgagee/Receiver Sale" type="checkbox" name="mortgagee_receiver_sale" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>
                                      <Form.Group as={Row} controlId="off_the_plan">
                                        <Col>
                                          <Form.Check checked={this.state.off_the_plan} onChange={this.handleCheckBoxChange} label="SOLD off the plan" type="checkbox" name="off_the_plan" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>
                                      <Form.Group as={Row} controlId="related_parties">
                                        <Col>
                                          <Form.Check checked={this.state.related_parties} onChange={this.handleCheckBoxChange} label="Buyer Vendor Related" type="checkbox" name="related_parties" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>
                                    </Col>
                                    <Col>
                                      <Form.Group as={Row} controlId="leasehold">
                                        <Col>
                                          <Form.Check checked={this.state.leasehold} onChange={this.handleCheckBoxChange} label="Leasehold Transfer" type="checkbox" name="leasehold" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="company_transfer">
                                        <Col>
                                          <Form.Check checked={this.state.company_transfer} onChange={this.handleCheckBoxChange} label="Company Transfer" type="checkbox" name="company_transfer" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>
                                      <Form.Group as={Row} controlId="extraordinary">
                                        <Col>
                                          <Form.Check checked={this.state.extraordinary} onChange={this.handleCheckBoxChange} label="Extraordinary" type="checkbox" name="extraordinary" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="includes_car_park">
                                        <Col>
                                          <Form.Check checked={this.state.includes_car_park} onChange={this.handleCheckBoxChange} label="Include car park" type="checkbox" name="includes_car_park" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>
                                    </Col>
                                  </Form.Row>
                                  <Form.Group as={Row} controlId="sale_notes">
                                    <span>&nbsp;&nbsp;</span>
                                    <Form.Label className="text-right">Sale Notes</Form.Label>

                                    <Form.Control onChange={this.handleChange} value={this.state.sale_notes} as="textarea" rows="4" onBlur={this.handleBlur} />
                                  </Form.Group>
                                </Card.Body>
                              </Card>

                              <Card id="col4head1">
                                <Card.Header>Agents </Card.Header>

                                <Card.Body>
                                  <Form.Group as={Row} controlId="agentSearchString">
                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                      Agency Search
                                    </Form.Label>
                                    <Col>
                                      <InputGroup size="sm">
                                        <Form.Control onChange={this.handleChange} value={this.state.agentSearchString} onKeyDown={this.handleEnterOnAgentSearch} as="input" type="text" placeholder="Search with % wildcard" />
                                        <InputGroup.Append>
                                          <Button onClick={this.handleAgentSearch} variant="outline-secondary" size="sm">
                                            Search
                                          </Button>
                                        </InputGroup.Append>
                                      </InputGroup>
                                    </Col>
                                  </Form.Group>
                                  <Form.Group as={Row} controlId="agentInterstateFlag">
                                    <Col sm={6} md={6} lg={4}></Col>
                                    <Col>
                                      <Form.Check checked={this.state.agentInterstateFlag} onChange={this.handleCheckBoxChange} label="Search interstate" type="checkbox" name="agentInterstateFlag" onBlur={this.handleBlur} />
                                    </Col>
                                  </Form.Group>
                                  <Form.Group as={Row} controlId="selectedAgent">
                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                      Agent
                                    </Form.Label>
                                    <Col>
                                      <Select value={this.state.selectedAgent} onChange={this.handleAgentChange} options={this.state.agentOptions} onInputChange={this.handleInputChange} onBlur={this.handleBlur} isClearable menuIsOpen={this.state.agentMenuIsOpen} />
                                    </Col>
                                  </Form.Group>

                                  <Row>
                                    <Col column sm={6} md={6} lg={4}></Col>
                                    <Col>
                                      <LinkContainer to={`../entities/new?saleid=${this.state.sale_id}`}>
                                        <Button variant="info" size="sm">
                                          Add New Agent
                                        </Button>
                                      </LinkContainer>{" "}
                                      {this.state.entity_id_agent && (
                                        <LinkContainer to={`../entities/${this.state.entity_id_agent}?saleid=${this.state.sale_id}`}>
                                          <Button size="sm" variant="info">
                                            Edit Existing Agent
                                          </Button>
                                        </LinkContainer>
                                      )}
                                    </Col>
                                  </Row>
                                  <br />
                                  <hr />
                                  <br />
                                  <Form.Group as={Row} controlId="coAgentSearchString">
                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                      Agency Search
                                    </Form.Label>
                                    <Col>
                                      <InputGroup size="sm">
                                        <Form.Control onChange={this.handleChange} value={this.state.coAgentSearchString} onKeyDown={this.handleEnterOnCoAgentSearch} as="input" type="text" placeholder="Search with % wildcard" />

                                        <InputGroup.Append>
                                          <Button onClick={this.handleCoAgentSearch} variant="outline-secondary" size="sm">
                                            Search
                                          </Button>
                                        </InputGroup.Append>
                                      </InputGroup>
                                    </Col>
                                  </Form.Group>

                                  <Form.Group as={Row} controlId="coAgentInterstateFlag">
                                    <Col sm={6} md={6} lg={4}></Col>
                                    <Col>
                                      <Form.Check checked={this.state.coAgentInterstateFlag} onChange={this.handleCheckBoxChange} label="Search interstate" type="checkbox" name="coAgentInterstateFlag" onBlur={this.handleBlur} />
                                    </Col>
                                  </Form.Group>

                                  <Form.Group as={Row} controlId="selectedCoAgent">
                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                      Co Agent
                                    </Form.Label>
                                    <Col>
                                      <Select value={this.state.selectedCoAgent} onChange={this.handleCoAgentChange} options={this.state.coAgentOptions} onInputChange={this.handleInputChange} onBlur={this.handleBlur} isClearable menuIsOpen={this.state.coAgentMenuIsOpen} />
                                    </Col>
                                  </Form.Group>
                                  <Row>
                                    <Col column sm={6} md={6} lg={4}></Col>
                                    <Col>
                                      <LinkContainer to={`../entities/new?saleid=${this.state.sale_id}`}>
                                        <Button variant="info" size="sm">
                                          Add New Agent
                                        </Button>
                                      </LinkContainer>{" "}
                                      {this.state.entity_id_co_agent && (
                                        <LinkContainer to={`../entities/${this.state.entity_id_co_agent}?saleid=${this.state.sale_id}`}>
                                          <Button size="sm" variant="info">
                                            Edit Existing Agent
                                          </Button>
                                        </LinkContainer>
                                      )}
                                    </Col>
                                  </Row>
                                </Card.Body>
                              </Card>
                            </Col>
                            <Col sm={12} md={6} lg={6}>
                              <PropertySaleList filter={this.state.propertySaleFilter} isAuthenticated={this.props.isAuthenticated} togglePropertySaleModal={this.togglePropertySaleModal} user={this.props.user} data={this.state.propertySales} updateTableState={this.updateTableState} saveRecord={this.saveRecord} validateRelatedRecord={this.validateRelatedRecord} deleteRecord={this.deleteRecord} removeHold={this.removeHold} saleid={this.state.sale_id} controlType="table2" areaSum={this.state.areaSum} getProperties={this.getProperties} propertyidlist={this.state.propertyidlist || []} userPermissions={this.props.userPermissions} />

                              <br />
                              <Row>
                                <Col sm={8} md={8} lg={8}>
                                  <Nav className="justify-content-start">
                                    <Nav.Item>
                                      <Button variant="info" onClick={this.addOwnerAsBuyerSeller} type="button" size="sm">
                                        Add Buyers/Vendors From Property
                                      </Button>{" "}
                                    </Nav.Item>

                                    <Nav.Item>
                                      <Button variant="info" onClick={this.removeVendorAsOwner} type="button" size="sm">
                                        Remove Vendors From Property
                                      </Button>{" "}
                                    </Nav.Item>
                                  </Nav>
                                </Col>
                                <Col>
                                  <Nav className="justify-content-end">
                                    <Nav.Item>
                                      <Button variant="info" onClick={this.toggleOwnerSearchDialog} type="button" size="sm">
                                        Search + Add Buyers/Vendors
                                      </Button>{" "}
                                    </Nav.Item>
                                  </Nav>
                                </Col>
                              </Row>
                              <br />
                              <SaleBuyerSellerList isAuthenticated={this.props.isAuthenticated} user={this.props.user} data={this.state.buyerSellers} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} refreshDataSet={this.refreshDataSet} controlType="table" validateRelatedRecord={this.validateRelatedRecord} buyerSellerOptions={this.state.buyerSellerOptions} />
                            </Col>
                          </Form.Row>
                        </Card.Body>
                      </Card>
                    </Tab>

                    {/* <Tab eventKey={3} title="Owner search">

                                        <Card >
                                            <Card.Body>
                                                <OwnerSearch
                                                    isAuthenticated={this.props.isAuthenticated}
                                                    user={this.props.user}
                                                    saleid={this.state.sale_id}
                                                    properties={this.state.propertySales}
                                                    controlType="table1"
                                                    buyerSellers={this.state.buyerSellers}
                                                    updateTableState={this.updateTableState}
                                                    saveRecord={this.saveRecord}
                                                    deleteRecord={this.deleteRecord}
                                                    refreshDataSet={this.refreshDataSet}
                                                />
                                            </Card.Body>
                                        </Card>
                                    </Tab> */}
                    <Tab eventKey={4} title="Record History">
                      <Card style={{ width: "28rem" }}>
                        <Card.Body>
                          <Form.Group as={Row} controlId="created_date">
                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                              Created Date
                            </Form.Label>
                            <Col>
                              <Form.Control value={this.state.created_date !== null ? Moment(this.state.created_date).local().format("DD-MM-YYYY") : ""} plaintext readOnly />
                            </Col>
                          </Form.Group>

                          <Form.Group as={Row} controlId="created_by">
                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                              Created By
                            </Form.Label>
                            <Col>
                              <Form.Control value={this.state.created_by} plaintext readOnly />
                            </Col>
                          </Form.Group>

                          <Form.Group as={Row} controlId="last_edited_date">
                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                              Last Edited Date
                            </Form.Label>
                            <Col>
                              <Form.Control value={this.state.last_edited_date !== null ? Moment(this.state.last_edited_date).local().format("DD-MM-YYYY") : ""} plaintext readOnly />
                            </Col>
                          </Form.Group>

                          <Form.Group as={Row} controlId="last_edited_by">
                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                              Last Edited By
                            </Form.Label>
                            <Col>
                              <Form.Control value={this.state.last_edited_by} plaintext readOnly />
                            </Col>
                          </Form.Group>
                        </Card.Body>
                      </Card>
                    </Tab>
                  </Tabs>
                </Col>
              </Row>
            </Form>
          </div>
        )}
      </div>
    );
  }
}
